module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/shop_studiosuns_01-2b6c870fbb4879bb1ec3e3b13ba74632.png";